import { DEFAULT_STATUS_COLOR, STATUS_COLORS } from "./constants";
import { GetStatusColor } from "./types";

export const getStatusColor: GetStatusColor = ({ status }) => {
  return STATUS_COLORS[status] ?? DEFAULT_STATUS_COLOR;
};
